import { TextFieldWidget } from '@tableau/widgets';
import React from 'react';

import { TypeUnsafeTranslation } from '~src/common/react/IReactTranslateService';
import { Keys } from '~src/ts/helpers/Keys';

import { IFilterControl, submitUrlQuery } from './FilterPanel';
import { filterComponent } from './FilterPanelStyles';


export interface TextFilterProps {
  readonly filterControl: IFilterControl;
  readonly shouldClear: boolean;
}

export function TextFilter(props: TextFilterProps) {
  const { filterControl } = props;
  const emptyValue = '';

  const [value, setValue] = React.useState<string>(emptyValue);

  const submit = (value: string) => {
    const params = filterControl.definition.valueToParams(value);
    submitUrlQuery(params);
  };

  const handleClear = () => {
    setValue(emptyValue);
    submit(emptyValue);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setValue(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    switch (e.which) {
      case Keys.Enter:
        e.preventDefault();
        e.stopPropagation();
        submit(value);
    }
  };

  // Needed for updates from the URL
  React.useEffect(
    () => {
      const updatedValue = filterControl.value;
      if (value !== updatedValue) {
        setValue(updatedValue ?? emptyValue);
      }
    },
    // This deps array was noncompliant before we enabled the lint rule. If you’re here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filterControl.value]
  );

  // Listen for clearing all filters
  React.useEffect(() => {
    if (props.shouldClear) {
      setValue(emptyValue);
    }
  }, [props.shouldClear]);

  const handleBlur = () => submit(value);

  return <>
    <TextFieldWidget
      className={filterComponent}
      kind={'outline'}
      label={TypeUnsafeTranslation.translate(filterControl.definition.name)}
      maxLength={200} // TODO what is the correct max length to introduce?
      onBlur={handleBlur}
      onChange={handleChange}
      onClear={handleClear}
      onKeyDown={handleKeyDown}
      style={{ width: '100%' }}
      testId={'text-filter-'+filterControl.definition.name}
      value={value}
    />
  </>;
}
